import React, { useState } from "react";
import RoomsContext from "./RoomsContext";

const RoomsState = (props) => {
  /**pagination states */
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);
  const [sortOrder, setSortOrder] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [filter, setFilter] = useState("");

  /**organization edit time condition and data object state */
  const [dialog, setdialogs] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [isBulk, setIsBulk] = useState(true);
  const [roomId, setRoomId] = useState(null);
  const [formData, setFormData] = useState({
    roomName: null,
    guestHouseId: null,
    address: null,
    categoryId: null,
    capacity: null,
    extraBed: null,
    facilities: null,
    to: null,
    from: null,
    // status: null,
  });
  return (
    <RoomsContext.Provider
      value={{
        pageSize,
        setPageSize,
        page,
        setPage,
        record,
        setRecord,
        sortOrder,
        setSortOrder,
        sortBy,
        setSortBy,
        filter,
        setFilter,
        dialog,
        setdialogs,
        isEdit,
        setIsEdit,
        roomId,
        setRoomId,
        formData,
        setFormData,
        isBulk,
        setIsBulk,
      }}
    >
      {props.children}
    </RoomsContext.Provider>
  );
};

export default RoomsState;
